import App from "./App.svelte"
import LogRocket from "logrocket"
LogRocket.init("ppdjtj/mpw-payments")

const app = new App({
  target: document.body
})

export default app
